export var ChatbotStepType;
(function (ChatbotStepType) {
    // User Interactions
    ChatbotStepType["MESSAGES"] = "MESSAGES";
    ChatbotStepType["INPUT"] = "INPUT";
    // Integrations
    ChatbotStepType["API"] = "API";
    // Operations
    ChatbotStepType["CONDITIONS"] = "CONDITIONS";
    ChatbotStepType["SET_CUSTOM_FIELDS"] = "SET_CUSTOM_FIELDS";
    ChatbotStepType["IDENTIFY_USER"] = "IDENTIFY_USER";
    // Endpoints
    ChatbotStepType["LIVE_CHAT"] = "LIVE_CHAT";
    ChatbotStepType["CONTACT_FORM"] = "CONTACT_FORM";
    ChatbotStepType["EXIT"] = "EXIT";
})(ChatbotStepType || (ChatbotStepType = {}));
;
export var ChatbotApiHttpMethod;
(function (ChatbotApiHttpMethod) {
    ChatbotApiHttpMethod["GET"] = "GET";
    ChatbotApiHttpMethod["POST"] = "POST";
    ChatbotApiHttpMethod["PUT"] = "PUT";
    ChatbotApiHttpMethod["DELETE"] = "DELETE";
})(ChatbotApiHttpMethod || (ChatbotApiHttpMethod = {}));
;
export var ChatbotConditionType;
(function (ChatbotConditionType) {
    ChatbotConditionType["EQUAL"] = "EQUAL";
    ChatbotConditionType["STARTS_WITH"] = "STARTS_WITH";
    ChatbotConditionType["EMAIL"] = "EMAIL";
    ChatbotConditionType["EMPTY"] = "EMPTY";
})(ChatbotConditionType || (ChatbotConditionType = {}));
;
export var blacklistedProperties = ['__proto__', 'constructor', 'hasOwnProperty', 'isPrototypeOf', 'propertyIsEnumerable', 'toLocaleString', 'toString', 'valueOf'];
//# sourceMappingURL=types.js.map